<template>
  <div class="no-default-calendar">
    <CalendarIcon class="icon" />
    <div class="content">
      <p class="title">No default calendar</p>
      <p class="description">
        Please set a default calendar to see your events.
      </p>
      <BaseButton
        kind="main"
        type="primary"
        text="Set default calendar"
        @click="goToCalendarSettings"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BaseButton from "@/components/base/BaseButton.vue";
import CalendarIcon from "@/components/icons/tabs/CalendarIcon.vue";
import * as inject from "@/components/inject";
import { RouteNames } from "@/routes/types";
import { navigateTo } from "@/utils/navigate";

export default defineComponent({
  name: "BaseNoDefaultCalendar",
  components: { CalendarIcon, BaseButton },
  setup() {
    const router = inject.router();

    const goToCalendarSettings = () => {
      navigateTo(RouteNames.SettingsCalendars, router);
    };

    return { goToCalendarSettings };
  },
});
</script>

<style scoped lang="scss">
.no-default-calendar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  height: 100%;
  min-height: 200px;

  .icon {
    width: 48px;
    height: 48px;
    margin-bottom: 16px;

    @include themed() {
      color: t($grey-40);
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 8px;
    max-width: 300px;
  }

  .title {
    margin: 0;
    @extend %font-body-medium;

    @include themed() {
      color: t($primary);
    }
  }

  .description {
    margin: 0;
    margin-bottom: 16px;
    @extend %font-caption-regular;

    @include themed() {
      color: t($grey-60);
    }

    a {
      text-decoration: underline;

      @include themed() {
        color: t($secondary);
      }

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
